<template>
  <div>
    <v-dialog v-model="mostrado" max-width="100%" scrollable persistent>
      <v-card>
        <v-card-title class="pt-2 pb-0">VISUALIZAR SOLICITUD</v-card-title>

        <v-divider class="my-2"></v-divider>

        <v-card-text class="pb-0">
          <v-row dense>
            <v-col v-if="cargando" cols="12">
              <v-responsive style="height: calc(100vh - 300px)">
                <div class="d-flex justify-center align-center" style="height: 100%">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                </div>
              </v-responsive>
            </v-col>

            <template v-else>
              <v-col v-if="!solicitud" cols="12">
                <v-responsive style="height: calc(100vh - 300px)">
                  <span class="d-block mt-4">No se encontraron datos de la solicitud.</span>
                </v-responsive>
              </v-col>

              <template v-else>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <ListItem titulo="NÚMERO" :subtitulo="solicitud.numero" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3">
                  <ListItem titulo="SEDE ORIGEN" :subtitulo="solicitud.sede_origen || '-'" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3">
                  <ListItem titulo="USUARIO" :subtitulo="solicitud.user || '-'" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3">
                  <ListItem titulo="TIPO" :subtitulo="obtenerTipoSolicitud(solicitud.tipo)" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3">
                  <ListItem titulo="TOTAL" :subtitulo="`Bs. ${formatearNumeroAMoneda(solicitud.total)}`" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-list class="py-0" dense>
                    <v-list-item two-line dense>
                      <v-list-item-content>
                        <v-list-item-title>ESTADO</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-chip x-small dark :color="obtenerColorEstadoSolicitud(solicitud.estado)">
                            {{ solicitud.estado }}
                          </v-chip>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3">
                  <ListItem titulo="FECHA SOLICITUD" :subtitulo="formatearFecha(solicitud.created_at)" />
                </v-col>

                <v-col cols="12" class="mt-2">
                  <span class="caption font-weight-bold">Detalle de la Solicitud</span>
                  <v-divider class="mt-1"></v-divider>
                </v-col>

                <v-col cols="12">
                  <v-simple-table dense>
                    <thead>
                      <tr>
                        <th class="px-2 caption">#</th>
                        <th class="px-2 caption">Clasificador</th>
                        <th class="px-2 caption">Sede Origen</th>
                        <th class="px-2 caption">Sede Destino</th>
                        <th class="px-2 caption">Banco Origen</th>
                        <th class="px-2 caption">Cuenta Origen</th>
                        <th class="px-2 caption">Banco Destino</th>
                        <th class="px-2 caption">Cuenta Destino</th>
                        <th class="px-2 caption" style="min-width: 300px">Detalle</th>
                        <th class="px-2 caption text-right">Importe</th>
                        <th class="px-2 caption text-right">Total Pagado</th>
                        <th class="px-2 caption text-right">Saldo</th>
                        <th class="px-2 caption">Tipo Desembolso</th>
                        <th class="px-2 caption">Estado</th>
                        <th class="px-2 caption">Tiene Reversión</th>
                        <th class="px-2 caption">Fecha Desembolso</th>
                        <th class="px-2 caption">Fecha Reversión</th>
                        <th class="px-2 caption" style="min-width: 200px">Observaciones</th>
                        <th class="px-2 caption text-center">Historial</th>
                        <th class="px-2 caption text-center">Pagos</th>
                        <th class="px-2 caption text-center">Reversión</th>
                      </tr>
                    </thead>

                    <tbody>
                      <template v-for="(detalle, indice) in solicitud.detalle_solicitud">
                        <tr :key="`detalle-${detalle.id}`">
                          <td class="px-2 caption">{{ indice + 1 }}</td>
                          <td class="px-2 caption" style="min-width: 180px">
                            <span class="d-block font-weight-medium">{{ detalle.clasificador.codigo }}</span>
                            <span class="d-block">{{ detalle.clasificador.nombre }}</span>
                          </td>
                          <td class="px-2 caption" style="min-width: 120px">{{ detalle.sede_origen }}</td>
                          <td class="px-2 caption" style="min-width: 120px">{{ detalle.sede_destino }}</td>
                          <td class="px-2 caption" style="min-width: 100px">{{ detalle.banco_origen }}</td>
                          <td class="px-2 caption">{{ detalle.cuenta_origen }}</td>
                          <td class="px-2 caption" style="min-width: 100px">{{ detalle.banco_destino }}</td>
                          <td class="px-2 caption">{{ detalle.cuenta_destino }}</td>
                          <td class="px-2 caption" style="min-width: 300px">{{ detalle.detalle }}</td>
                          <td class="px-2 caption text-right">{{ formatearNumeroAMoneda(detalle.importe) }}</td>
                          <td class="px-2 caption text-right">
                            {{ formatearNumeroAMoneda(calcularTotalPagado(detalle)) }}
                          </td>
                          <td class="px-2 caption text-right">{{ formatearNumeroAMoneda(calcularSaldo(detalle)) }}</td>
                          <td class="px-2 caption">{{ detalle.tipo_desembolso || '-' }}</td>
                          <td class="px-2 caption">
                            <v-chip x-small dark :color="obtenerColorEstadoDetalleSolicitud(detalle.estado)">
                              {{ detalle.estado }}
                            </v-chip>
                          </td>
                          <td class="px-2 caption">
                            <v-chip
                              x-small
                              dark
                              :color="
                                [
                                  estadosDetalleSolicitud.DESEMBOLSADO,
                                  estadosDetalleSolicitud.PAGADO_PARCIALMENTE,
                                ].includes(detalle.estado)
                                  ? detalle.detalle_solicitud_reversion_id
                                    ? '#4caf50'
                                    : '#f44336'
                                  : '#9e9e9e'
                              ">
                              {{
                                [
                                  estadosDetalleSolicitud.DESEMBOLSADO,
                                  estadosDetalleSolicitud.PAGADO_PARCIALMENTE,
                                ].includes(detalle.estado)
                                  ? detalle.detalle_solicitud_reversion_id
                                    ? 'Sí'
                                    : 'No'
                                  : 'N/A'
                              }}
                            </v-chip>
                          </td>
                          <td class="px-2 caption" style="min-width: 140px">
                            {{ detalle.fecha_desembolso ? formatearFecha(detalle.fecha_desembolso) : '-' }}
                          </td>
                          <td class="px-2 caption" style="min-width: 140px">
                            {{ detalle.fecha_reversion ? formatearFecha(detalle.fecha_reversion) : '-' }}
                          </td>
                          <td class="px-2 caption">{{ detalle.observaciones || '-' }}</td>
                          <td class="px-2 caption text-center">
                            <v-btn
                              color="primary"
                              :title="expandidosHistorial[detalle.id] ? 'Ocultar historial' : 'Ver historial'"
                              icon
                              @click="toggleHistorial(detalle.id)">
                              <v-icon>
                                {{ expandidosHistorial[detalle.id] ? 'mdi-chevron-up' : 'mdi-history' }}
                              </v-icon>
                            </v-btn>
                          </td>
                          <td class="px-2 caption text-center">
                            <v-btn
                              icon
                              color="teal"
                              :title="expandidosPagos[detalle.id] ? 'Ocultar pagos' : 'Ver pagos'"
                              @click="togglePagos(detalle.id)">
                              <v-icon>
                                {{ expandidosPagos[detalle.id] ? 'mdi-chevron-up' : 'mdi-cash-multiple' }}
                              </v-icon>
                            </v-btn>
                          </td>
                          <td class="px-2 caption text-center">
                            <v-btn
                              v-if="
                                [
                                  estadosDetalleSolicitud.DESEMBOLSADO,
                                  estadosDetalleSolicitud.PAGADO_PARCIALMENTE,
                                ].includes(detalle.estado)
                              "
                              color="red"
                              title="Registrar reversión"
                              :disabled="!!detalle.detalle_solicitud_reversion_id"
                              icon
                              @click="$refs.modalReversionDetalleSolicitud.abrir(detalle, solicitud.id)">
                              <v-icon> mdi-rotate-left </v-icon>
                            </v-btn>

                            <span v-else class="caption grey--text">N/A</span>
                          </td>
                        </tr>

                        <tr v-if="expandidosHistorial[detalle.id]" :key="`historial-${detalle.id}`">
                          <td colspan="20" class="pa-2">
                            <p class="caption font-weight-bold mb-1">Historial del detalle</p>
                            <v-simple-table dense>
                              <thead>
                                <tr>
                                  <th class="px-2 caption">Estado Anterior</th>
                                  <th class="px-2 caption">Estado Actual</th>
                                  <th class="px-2 caption">Procesado Por</th>
                                  <th class="px-2 caption" style="min-width: 300px">Motivo</th>
                                  <th class="px-2 caption">Fecha</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(historial, hIndice) in detalle.detalles_solicitudes_historial"
                                  :key="hIndice">
                                  <td class="px-2 caption">{{ historial.estado_anterior || '-' }}</td>
                                  <td class="px-2 caption">{{ historial.estado_actual }}</td>
                                  <td class="px-2 caption">{{ historial.procesado_por }}</td>
                                  <td class="px-2 caption">{{ historial.motivo || '-' }}</td>
                                  <td class="px-2 caption">{{ formatearFecha(historial.creado_en) }}</td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </td>
                        </tr>

                        <tr v-if="expandidosPagos[detalle.id]" :key="`pagos-${detalle.id}`">
                          <td colspan="20" class="pa-2">
                            <p class="caption font-weight-bold mb-1">Pagos del detalle</p>
                            <v-simple-table dense>
                              <thead>
                                <tr>
                                  <th class="px-2 caption">N° Comprobante</th>
                                  <th class="px-2 caption">Fecha</th>
                                  <th class="px-2 caption">Monto</th>
                                  <th class="px-2 caption">Registrado Por</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-if="
                                    !detalle.pagos_detalles_solicitudes || !detalle.pagos_detalles_solicitudes.length
                                  ">
                                  <td colspan="4" class="px-2 caption text-center">Sin pagos registrados</td>
                                </tr>
                                <tr v-for="(pago, pIndice) in detalle.pagos_detalles_solicitudes" :key="pIndice">
                                  <td class="px-2 caption">{{ pago.numero_comprobante || '-' }}</td>
                                  <td class="px-2 caption">{{ formatearFecha(pago.fecha) }}</td>
                                  <td class="px-2 caption">{{ formatearNumeroAMoneda(pago.monto) }}</td>
                                  <td class="px-2 caption">{{ pago.registrado_por || '-' }}</td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </template>
            </template>
          </v-row>
        </v-card-text>

        <v-divider class="my-2"></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey" small rounded dark @click="cerrar">
            <v-icon small>mdi-close</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <notifications group="notifications" position="top right" />

    <ModalFormRegistrarReversionDetalleSolicitud ref="modalReversionDetalleSolicitud" @guardado="obtenerSolicitud" />
  </div>
</template>

<script>
import moment from 'moment';
import solicitudesService from '../../../gastos/services/solicitudes.service';
import ListItem from '../../../gastos/components/ListItem.vue';
import { formatearNumeroAMoneda } from '../../../gastos/utils/funciones';
import { obtenerColorEstadoDetalleSolicitud, TIPOS_SOLICITUD, ESTADOS_SOLICITUD } from '../../utils';
import ModalFormRegistrarReversionDetalleSolicitud from './ModalFormRegistrarReversionDetalleSolicitud.vue';
import { ESTADOS_DETALLE_SOLICITUD } from '../../utils';

export default {
  name: 'VisualizarSolicitud',
  components: {
    ListItem,
    ModalFormRegistrarReversionDetalleSolicitud,
  },
  data() {
    return {
      mostrado: false,
      solicitudId: null,
      solicitud: null,
      cargando: false,
      expandidosHistorial: {},
      expandidosPagos: {},
      estadosDetalleSolicitud: ESTADOS_DETALLE_SOLICITUD,
    };
  },
  methods: {
    abrir(id) {
      this.solicitudId = id;
      this.solicitud = null;
      this.mostrado = true;
      this.obtenerSolicitud();
    },
    cerrar() {
      this.mostrado = false;
      this.solicitudId = null;
      this.solicitud = null;
      this.expandidosHistorial = {};
      this.expandidosPagos = {};
    },
    async obtenerSolicitud() {
      if (!this.solicitudId) {
        return;
      }

      this.cargando = true;
      this.solicitud = null;

      try {
        const response = await solicitudesService.findOne(this.solicitudId);
        const { datos, mensaje } = response?.data;

        this.solicitud = datos;
        this.$notify({
          group: 'notifications',
          title: 'Solicitud',
          text: mensaje || 'Solicitud encontrada',
          type: 'success',
        });
      } catch (error) {
        const data = error?.response?.data;
        const mensaje = data?.mensaje || error.message || 'Error al obtener la solicitud';

        window.console.error(error);
        this.$notify({
          group: 'notifications',
          title: 'Solicitud',
          text: mensaje,
          type: 'error',
        });

        this.solicitud = null;
      } finally {
        this.cargando = false;
      }
    },
    toggleHistorial(detalleId) {
      this.$set(this.expandidosHistorial, detalleId, !this.expandidosHistorial[detalleId]);
    },
    togglePagos(detalleId) {
      this.$set(this.expandidosPagos, detalleId, !this.expandidosPagos[detalleId]);
    },
    calcularTotalPagado(detalle) {
      if (!detalle.pagos_detalles_solicitudes || !detalle.pagos_detalles_solicitudes.length) return 0;
      return detalle.pagos_detalles_solicitudes.reduce((acc, pago) => acc + parseFloat(pago.monto || 0), 0);
    },
    calcularSaldo(detalle) {
      return parseFloat(detalle.importe || 0) - this.calcularTotalPagado(detalle);
    },
    formatearNumeroAMoneda(valor) {
      return formatearNumeroAMoneda(valor);
    },
    formatearFecha(fecha) {
      return moment(fecha).format('DD/MM/YYYY HH:mm:ss');
    },
    obtenerColorEstadoDetalleSolicitud(estado) {
      return obtenerColorEstadoDetalleSolicitud(estado);
    },
    obtenerColorEstadoSolicitud(estado) {
      if (estado === ESTADOS_SOLICITUD.ATENDIDO) return '#4caf50';
      if (estado === ESTADOS_SOLICITUD.SOLICITADO) return '#ff9800';
      return '#607d8b';
    },
    obtenerTipoSolicitud(tipo) {
      return tipo === TIPOS_SOLICITUD.RECURSOS ? 'Sedes' : 'Nacional';
    },
  },
};
</script>
